import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { STORAGE_KEYS } from './constants';

let cached: string | null = null;
let pending: Promise<string> | null = null;

export async function ensureFingerprint(): Promise<string> {
  if (cached) return cached;
  const stored = localStorage.getItem(STORAGE_KEYS.fingerprint);
  if (stored) {
    cached = stored;
    return stored;
  }
  if (pending) return pending;
  pending = (async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    cached = result.visitorId;
    localStorage.setItem(STORAGE_KEYS.fingerprint, cached);
    return cached;
  })();
  return pending;
}

export function getCachedFingerprint(): string | null {
  return cached ?? localStorage.getItem(STORAGE_KEYS.fingerprint);
}
